export default function SettingIcon() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.67824 5.44054C3.8048 5.17335 3.95246 4.92023 4.12121 4.67413L4.09308 2.84601C4.09308 2.67726 4.16339 2.51554 4.29699 2.40304C4.95089 1.8546 5.69621 1.41163 6.51886 1.11632C6.68058 1.06007 6.85636 1.07413 6.99699 1.16554L8.56496 2.10773C8.86027 2.08663 9.15558 2.08663 9.45089 2.10773L11.0189 1.16554C11.1665 1.08116 11.3423 1.06007 11.504 1.11632C12.3056 1.4046 13.0579 1.83351 13.7259 2.39601C13.8525 2.50148 13.9298 2.67023 13.9228 2.83898L13.8946 4.6671C14.0634 4.9132 14.211 5.16632 14.3376 5.43351L15.9337 6.31945C16.0814 6.40382 16.1868 6.54445 16.215 6.7132C16.3626 7.54991 16.3696 8.42179 16.215 9.27257C16.1868 9.44132 16.0814 9.58195 15.9337 9.66632L14.3376 10.5523C14.211 10.8194 14.0634 11.0726 13.8946 11.3187L13.9228 13.1468C13.9228 13.3155 13.8525 13.4773 13.7189 13.5898C13.065 14.1382 12.3196 14.5812 11.497 14.8765C11.3353 14.9327 11.1595 14.9187 11.0189 14.8273L9.45089 13.8851C9.15558 13.9062 8.86027 13.9062 8.56496 13.8851L6.99699 14.8273C6.84933 14.9116 6.67355 14.9327 6.51183 14.8765C5.71027 14.5882 4.95793 14.1593 4.28996 13.5968C4.16339 13.4913 4.08605 13.3226 4.09308 13.1538L4.12121 11.3257C3.95246 11.0796 3.8048 10.8265 3.67824 10.5593L2.08214 9.67335C1.93449 9.58898 1.82902 9.44835 1.80089 9.2796C1.65324 8.44288 1.64621 7.57101 1.80089 6.72023C1.82902 6.55148 1.93449 6.41085 2.08214 6.32648L3.67824 5.44054Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00082 11.3749C10.8648 11.3749 12.3758 9.86389 12.3758 7.99993C12.3758 6.13597 10.8648 4.62493 9.00082 4.62493C7.13686 4.62493 5.62582 6.13597 5.62582 7.99993C5.62582 9.86389 7.13686 11.3749 9.00082 11.3749Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
